// SubscribeButton.js
import React, { useMemo } from 'react';
import "./SubscribeButton.css"; 
import { useNavigate } from 'react-router-dom';
import { useCart } from '../../Utilities/useCart';

const SubscribeButton = ({ classData, classId }) => {
  console.log('VideoSubscription classData:', classData, classId);
  const navigate = useNavigate();
  const { addToCart, isInCart } = useCart();

  // Generate Thumbnail Source
  const thumbnailSrc = useMemo(() => {
    if (!classData?.thumbnail) return '';
    const isBase64 = classData.thumbnail.length > 100 && /^[A-Za-z0-9+/=]+$/.test(classData.thumbnail);
    return isBase64 ? `data:image/jpeg;base64,${classData.thumbnail}` : classData.thumbnail;
  }, [classData?.thumbnail]);

  const handleAddToCart = () => {
    const cartItem = {
      id: classId,
      title: classData.title,
      instructor: classData.instructor,
      price: classData.cost,
      thumbnail: classData.thumbnail,
      education_class: classData.education_class,
      quantity: 1,
      type: 'subscription',
      class_uid: classId, 
    };

    if (!isInCart(classId)) {
      addToCart(cartItem);
    }

    navigate('/cart', { state: { classId: classId } });
  };

  // Don't render the button if already subscribed
  if (classData?.subscribed) {
    return null;
  }

  return (
    <button className="subscribe-button1" onClick={handleAddToCart}>
      {isInCart(classId) ? 'In Cart' : 'Subscribe Class'}
    </button>
  );
};

export default SubscribeButton;